import styled from "styled-components";

export const FiltroCheckContainer = styled.div`
  display: flex;
  flex-direction: column;
  user-select: none;
  label {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    padding-right: 70px;
    cursor: pointer;
    color: var(--color-latex15);
    font-size: 22px;
    font-weight: 500;
  }
  .FiltroCheck-checkbox {
    margin-top: 2px;
    height: 30px;
    min-height: 30px;
    accent-color: var(--color-latex30);
    width: 30px;
    min-width: 30px;
  }
`;
export const FiltroCheckHeader = styled.div`
  font-size: 20px;
  color: var(--color-latex10);
  .FiltroCheckHeader-input {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 40px;
  }
`;
export const FiltroCheckBody = styled.div`
  display: flex;
  padding-left: 30px;
  gap: 16px;
`;

export const FiltroCheckElementos = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 20px;

  .FiltroCheckElemento {
    display: flex;
    gap: 40px;
  }
  .FiltroCheckElemento-label {
    display: flex;
    flex-direction: column;
  }
  .FiltroCheckElemento-labelBlack {
    font-size: 22px;
    color: var(--color-latex15);
    font-weight: 500;
  }
  .FiltroCheckElemento-labelBlue {
    font-size: 20px;
    font-weight: 300;
    color: #3880ff;
  }
`;

export const FiltroCheckFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 32px;
  padding-top: 24px;
  .FiltroCheckBtn {
    width: 359px;
    height: 38px;
    background-color: var(--color-primary);
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-white);
    cursor: pointer;
    border-radius: 8px;
  }
`;
